import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import {
  VoucherCodeInputModalComponent
} from '../voucher-code-input-modal/voucher-code-input-modal.component';
import {
  VoucherDetailsModalComponent
} from '../voucher-details-modal/voucher-details-modal.component';
import { IVoucherDetails } from '../../core/interfaces/IVoucherDetails';
import { IVoucherTransaction } from '../../core/interfaces/IVoucherTransaction';
import {
  CardDetailsModalComponent
} from '../../../cards/modals/card-details-modal/card-details-modal.component';
import { ICard } from '../../../cards/core/interfaces/ICard';

@Component({
  selector: 'app-voucher-actions-modal',
  standalone: true,
  imports: [
    TranslatePipe,
    ModalComponent,
    VoucherCodeInputModalComponent,
    VoucherDetailsModalComponent,
    CardDetailsModalComponent
  ],
  templateUrl: './voucher-actions-modal.component.html',
  styleUrl: './voucher-actions-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VoucherActionsModalComponent extends BaseModalComponent {

  @ViewChild('voucherCodeInputModalComponent') voucherCodeInputModalComponent: VoucherCodeInputModalComponent;
  @ViewChild('voucherDetailsModalComponent') voucherDetailsModalComponent: VoucherDetailsModalComponent;
  @ViewChild('cardDetailsModalComponent') cardDetailsModalComponent: CardDetailsModalComponent;

  public override open(val?: null): void {
    super.open(val);
  }

  public openVoucherDetails(): void {
    this.close();
    this.voucherCodeInputModalComponent.open(null, 'details');
  }

  public openCancelVoucher(): void {
    this.close();
    this.voucherCodeInputModalComponent.open(null, 'cancel');
  }

  public openInvalidateVoucher(): void {
    this.close();
    this.voucherCodeInputModalComponent.open(null, 'invalidate');
  }

  public onVoucherCodeSubmitted(event: { voucherNumber: string; voucherDetails?: IVoucherDetails; transactions?: IVoucherTransaction[]; actionType?: 'details' | 'cancel' | 'invalidate' }): void {
    if (event.actionType === 'details' && event.voucherDetails) {
      this.voucherCodeInputModalComponent.close();
      this.voucherDetailsModalComponent.open(event.voucherDetails, event.transactions);
    }
  }

  public onCardDetailsRequested(card: ICard): void {
    this.cardDetailsModalComponent.open({ card });
  }
}
